import {
  K8UpdateConfigurationPage,
  K8UpdateConfigurationProps,
} from "~/pages/integrations/kubernetes/K8UpdateConfigurationPage";

const K8UpdateConfigurationEntryPage = ({
  scope,
}: K8UpdateConfigurationProps) => {
  return <K8UpdateConfigurationPage {...{ scope }} />;
};

export default K8UpdateConfigurationEntryPage;
